import type { SelectableListItem } from '../../../../components/modals'
import styles from './models-modal-fuzzy-search.module.scss'

export interface ModelsModalFuzzySearchProps {
    results?: Fuzzysort.KeyResults<SelectableListItem>
    selectedIds?: Set<string>
    onSelect?(modelId: string): void
}

export const ModelsModalFuzzySearch = ({
    results,
    selectedIds,
    onSelect,
}: ModelsModalFuzzySearchProps) => {
    if (!results || results.length === 0) {
        return (
            <div className={styles.container}>
                <div className={styles.emptyState}>No similar models found</div>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>Similar models</div>

            {results.map((result) => {
                return (
                    <div key={result.obj.id} className={styles.resultRow}>
                        <span>{Math.round(result.score * 100)}%</span>

                        <span className={styles.modelName}>
                            {result.obj.name}
                        </span>

                        {selectedIds?.has(result.obj.id) ? (
                            <span className={styles.selectedText}>
                                Selected
                            </span>
                        ) : (
                            <span
                                className={styles.selectAction}
                                onClick={() => onSelect?.(result.obj.id)}>
                                select
                            </span>
                        )}
                    </div>
                )
            })}
        </div>
    )
}
